// extracted by mini-css-extract-plugin
module.exports = {"container":"AverageSalary_container__3uj4v","button":"AverageSalary_button__3HgQp"};